document.addEventListener('click', (e) => {
  const tagEl = e.target.closest('[data-tag-link]');
  if (!tagEl) return;
  e.preventDefault();
  e.stopPropagation();
  window.location.href = tagEl.dataset.tagLink;
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-blog-tab-filter]').forEach((section) => {
    const tabBtns = [...section.querySelectorAll('[data-tab-btn]')];
    const grid = section.querySelector('[data-tab-grid]');
    const loader = section.querySelector('[data-blog-loader]');
    const sentinel = section.querySelector('[data-load-sentinel]');

    if (!tabBtns.length || !grid) return;

    const BATCH_SIZE = 8;
    let revealedCount = BATCH_SIZE;
    let activeTab = 'all';
    let scrollObserver = null;

    const getCards = () => [...section.querySelectorAll('[data-article-card]')];

    const showLoader = () => loader?.classList.add('is-loading');
    const hideLoader = () => loader?.classList.remove('is-loading');

    const revealBatch = (cards) => {
      const next = cards.slice(revealedCount, revealedCount + BATCH_SIZE);
      if (!next.length) return false;
      next.forEach((c) => c.classList.remove('is-deferred'));
      revealedCount += next.length;
      return true;
    };

    const applyDeferredState = (cards) => {
      cards.forEach((card, i) => {
        card.classList.remove('is-hidden');
        card.classList.toggle('is-deferred', i >= revealedCount);
      });
    };

    const setupObserver = (cards) => {
      if (scrollObserver) scrollObserver.disconnect();
      if (!sentinel || revealedCount >= cards.length) return;

      scrollObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            if (activeTab !== 'all') continue;
            scrollObserver.disconnect();
            showLoader();
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                revealBatch(cards);
                hideLoader();
                initScrollLoad(cards);
              });
            });
          }
        },
        { rootMargin: '0px' }
      );

      scrollObserver.observe(sentinel);
    };

    const initScrollLoad = (cards) => {
      if (scrollObserver) scrollObserver.disconnect();
      if (revealedCount >= cards.length) return;

      // Synchronously reveal batches until the sentinel is below the fold.
      // All DOM mutations happen in one block before the browser paints,
      // so the user never sees intermediate states (no flash/glitch).
      // getBoundingClientRect() forces a layout reflow after each mutation,
      // giving an accurate sentinel position with newly visible cards included.
      while (revealedCount < cards.length) {
        const sentinelRect = sentinel?.getBoundingClientRect();
        if (sentinelRect && sentinelRect.top > window.innerHeight) break;
        revealBatch(cards);
      }

      setupObserver(cards);
    };

    const applyFilter = (tabValue, cards) => {
      requestAnimationFrame(() => {
        if (tabValue === 'all') {
          applyDeferredState(cards);
          initScrollLoad(cards);
        } else {
          if (scrollObserver) scrollObserver.disconnect();
          cards.forEach((card) => {
            const cardTags = card.dataset.tags?.split('|') ?? [];
            const matches = cardTags.some((tag) => tag.trim() === tabValue);
            card.classList.remove('is-deferred');
            card.classList.toggle('is-hidden', !matches);
          });
        }
      });
    };

    const hideEmptyTabs = () => {
      const cards = getCards();
      tabBtns.forEach((btn) => {
        const { tabValue } = btn.dataset;
        if (tabValue === 'all') return;
        const hasMatch = cards.some((card) => {
          const cardTags = card.dataset.tags?.split('|') ?? [];
          return cardTags.includes(tabValue);
        });
        btn.classList.toggle('is-tab-empty', !hasMatch);
      });
    };

    tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const { tabValue } = btn.dataset;
        activeTab = tabValue;
        tabBtns.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        applyFilter(tabValue, getCards());
      });
    });

    hideEmptyTabs();
    initScrollLoad(getCards());
  });
});
